/**
 * TutorPrepareLiveScreen — « Préparer mon live » (`tutor/prepare-live`) : la tâche « Prépare ton
 * live » de l'accueil, le lien du mail « lives du jour » et le push du même chemin. Sans stage à
 * préparer, il renvoie à « Ma journée ». Un fil : les lectures, les gestes, le view-model, la page, et
 * le bandeau d'une mise à jour refusée.
 */
import React from "react"
import { useSelector } from "react-redux"

import { Snackbar } from "../../../../../../design-system"
import { TutorPrepareLivePage } from "../../../../../../design-system/tutor"
import { tutorPrepareLiveViewModel } from "../../../../view-models/tutor/Lives/tutorPrepareLiveViewModel"
import { useTutorPrepareLiveData } from "./useTutorPrepareLiveData"
import { useTutorPrepareLiveState } from "./useTutorPrepareLiveState"

export function TutorPrepareLiveScreen() {
    const data = useTutorPrepareLiveData()
    const state = useTutorPrepareLiveState(data.raw, data.refetch)
    const vm = useSelector((s: unknown) =>
        tutorPrepareLiveViewModel(s, { raw: data.raw, updatingKey: state.updatingKey })
    )

    if (state.leaving) return null
    return (
        <>
            <TutorPrepareLivePage
                occurrences={vm.occurrences}
                subjects={vm.subjects}
                loading={data.loading}
                error={data.error}
                onRetry={data.refetch}
                {...state.gestures}
                testID="tutor-prepare-live"
            />
            <Snackbar
                visible={state.failure != null}
                message={state.failure ?? ""}
                tone="danger"
                onDismiss={state.dismissFailure}
            />
        </>
    )
}
